import { render } from "./GridTable.vue?vue&type=template&id=5dcff970&scoped=true"
import script from "./GridTable.vue?vue&type=script&lang=js"
export * from "./GridTable.vue?vue&type=script&lang=js"

import "./GridTable.vue?vue&type=style&index=0&id=5dcff970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcff970"]])

export default __exports__